/**
 * Extract error message from API response
 * Handles both string errors and Pydantic validation errors (array of objects)
 */
export const getErrorMessage = (error, fallback = 'Une erreur est survenue') => {
  if (!error?.response?.data) {
    return error?.message || fallback;
  }

  const detail = error.response.data.detail;

  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array (Pydantic validation errors), extract messages
  if (Array.isArray(detail)) {
    // Get the first error message or combine them
    const messages = detail
      .map(err => err.msg || err.message || JSON.stringify(err))
      .filter(Boolean);
    
    if (messages.length === 1) {
      return messages[0];
    }
    
    if (messages.length > 1) {
      return messages.join(', ');
    }
  }

  // If detail is an object with a message property
  if (detail?.msg || detail?.message) {
    return detail.msg || detail.message;
  }

  // Fallback
  return fallback;
};
